module.exports = __webpack_public_path__ + "fonts/b8a466fce4e94e1b2ba1955e19002192.svg";